(function() {
    const doc = require('./dom').doc;
    const dateopts = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    };

    doc.id("output").textContent = JSON.stringify({
                                                     navigator: {
                                                       language: navigator.language,
                                                       languages: navigator.languages },
                                                     resolved: {
                                                       undefined: {
                                                         locale: (new Intl.DateTimeFormat(undefined)).resolvedOptions().locale,
                                                         now: (new Intl.DateTimeFormat(undefined, dateopts)).format(Date.now()),
                                                       },
                                                       navigator_language: {
                                                         locale: (new Intl.DateTimeFormat(window.navigator.languages)).resolvedOptions().locale,
                                                         now: (new Intl.DateTimeFormat(window.navigator.languages, dateopts)).format(Date.now()),
                                                       },
                                                     },
                                                   },
                                                   undefined, "  ");
})()(function() {
    const doc = require('./dom').doc;
    const dateopts = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    };

    doc.id("output").textContent = JSON.stringify({
                                                     navigator: {
                                                       language: navigator.language,
                                                       languages: navigator.languages },
                                                     resolved: {
                                                       undefined: {
                                                         locale: (new Intl.DateTimeFormat(undefined)).resolvedOptions().locale,
                                                         now: (new Intl.DateTimeFormat(undefined, dateopts)).format(Date.now()),
                                                       },
                                                       navigator_language: {
                                                         locale: (new Intl.DateTimeFormat(window.navigator.languages)).resolvedOptions().locale,
                                                         now: (new Intl.DateTimeFormat(window.navigator.languages, dateopts)).format(Date.now()),
                                                       },
                                                     },
                                                   },
                                                   undefined, "  ");
})()